module.exports = __webpack_public_path__ + "static/img/1000000466_green.fab7baca.jpg";